import { render, staticRenderFns } from "./24.vue?vue&type=template&id=6d1e26b4&scoped=true&"
import script from "./24.vue?vue&type=script&lang=js&"
export * from "./24.vue?vue&type=script&lang=js&"
import style0 from "./24.vue?vue&type=style&index=0&id=6d1e26b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1e26b4",
  null
  
)

export default component.exports